// extracted by mini-css-extract-plugin
export default {"cartBorder":"CartBorder_cartBorder__V0TmX"};